import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import KobooTablePagination from '../Layout/KobooTablePagination.jsx';
import StandRow from './StandRow';
import { getStands, postStand } from '../../store/stands/actions';
import StandTableHead from './StandTableHead';
import Loader from '../Layout/Loader';
import KobooButton from '../Layout/KobooButton';
import KobooDialog from '../Layout/KobooDialog.jsx';
import { getBikes } from '../../store/bikes/actions';

const INITIAL_STATE = {
  dialog: {
    open: false,
    item: '',
  },
  page: 0,
  rowsPerPage: 500
};

export class StandTable extends Component {
  static propTypes = {
    sites: PropTypes.array.isRequired,
    site_id: PropTypes.string.isRequired
  };

  constructor(props, context) {
    super(props, context);
    this.state = { ...INITIAL_STATE };
  }

  static getDerivedStateFromProps(props) {
    let newState = null;
    if (props.authUser && props.roles) {
      const authUserRole = props.roles[props.authUser.uid];
      newState = {...newState, role:authUserRole};
      if (!props.stands && !props.pendingStands) {
        props.getStands(props.authUser.ma, authUserRole);
      }
      if (!props.bikes && !props.pendingBikes) {
        props.getBikes(props.authUser.ma, authUserRole);
      }
    }
    return newState;
  }

  // Handler

  handleClose = () => {
    this.setState({ ...INITIAL_STATE });
  };

  handleClickOpen = () => {
    this.setState({ dialog: {
        ...this.state.dialog,
        open: true,

      }});
  };

  handleClickAddStand = (event) => {
    this.handleClose();
    this.props.postStand(
      this.props.authUser.ma,
      this.props.site_id,
      {
        number: Number(this.state.dialog.item),
      },
    );
    event.preventDefault();
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  render() {
    const { stands, bikes, sites, pending, sending, site_id } = this.props;

    const { rowsPerPage, page } = this.state;

    let body = <Typography variant="subtitle1">Aucune borne</Typography>;
    let alreadyExistsStandItem = false;

    if (pending || sending) {
      return (<Loader />);
    } else if (Array.isArray(stands)) {
      const filteredStands = stands.filter(stand=> stand.site_id === site_id);
      alreadyExistsStandItem = filteredStands.filter(stand =>
        stand.number === Number(this.state.dialog.item)).length > 0;
      if (bikes && filteredStands.length > 0) {
        body =
          <div>
            <Table>
              <StandTableHead/>
              <TableBody>
                {filteredStands.map(stand => (
                  <StandRow
                    key={stand.id}
                    stand={stand}
                    bike={bikes.find(bike => bike.id === stand.bike_id)}
                    stands={filteredStands}
                    container={sites.find(site => site.id === site_id)}
                  />
                ))}
              </TableBody>
            </Table>
            <KobooTablePagination
              id="pagination"
              numberOfItems={filteredStands.length}
              rowsPerPage={rowsPerPage}
              label="Bornes par page"
              page={page}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
            />
          </div>
      }

    }
    return (

      <Grid item xs={12} sm={12} md={12}>
        <KobooDialog
          id="dialog_add_stand"
          open={this.state.dialog.open}
          handleClose={this.handleClose}
          dialogTitle="Voulez-vous ajouter une nouvelle borne à ce site ?"
          handleCloseCancel={this.handleClose}
          handleCloseOK={event => this.handleClickAddStand(event)}
          textField={<TextField
            value={this.state.dialog.item}
            onChange={event => this.setState({
              dialog: {
                ...this.state.dialog,
                item: event.target.value
              }
            })}
            label="Numéro de la borne"
            placeholder="Numéro de la borne"
            helperText={alreadyExistsStandItem ?
              "Cet numéro est déjà utilisé" : ""}
            type="text"
            margin="normal"
            error={alreadyExistsStandItem}

          />}
          cancelText="ANNULER"
          okText="VALIDER"
          disabled={alreadyExistsStandItem}
        />
        <Toolbar>
          <KobooButton
            id='button_open_dialog'
            onClick={this.handleClickOpen}
          >
            Ajouter une borne
          </KobooButton>
        </Toolbar>
        {body}
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    roles: state.roles.content,
    pending: state.stands.pending || state.bikes.pending,
    sending: state.stands.sending,
    stands: state.stands.content,
    bikes: state.bikes.content,
    pendingStands: state.stands.pending,
    pendingBikes: state.bikes.pending
  };
}

export default connect(mapStateToProps, {getStands, getBikes, postStand})(StandTable);



// WEBPACK FOOTER //
// ./src/components/Stand/StandTable.jsx